import React from 'react';
import partnerBanner from '../../assets/Partnerwithus/partnerwithus_banner.png';
import '../../styles/PartnerWithUs.css';

function PartnerBannerImage() {
  return (
    <section className="partnerBanner">
      <img src={partnerBanner} alt="Partner With Us Banner" />
    </section>
  );
}

export default PartnerBannerImage;
